export const LOGOUT = 'login/LOGOUT';
export const RESET_IDLE_TIME = 'login/RESET_IDLE_TIME';
